import { SignInRoute } from "../SignInRoute";
import { SignInCenteredLayout } from "../layouts/SignInCenteredLayout";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

export function ForgotPasswordPage() {
  return (
    <SignInRoute>
      <SignInCenteredLayout
        kicker="Account Recovery"
        headline={<>Reset your <em>password</em>.</>}
        lede="Enter your email and we'll send you a one-time code. Then choose a new password."
        sectionTitle="Forgot password"
      >
        <ForgotPasswordForm />
      </SignInCenteredLayout>
    </SignInRoute>
  );
}
